<h1 mat-dialog-title>{{ 'liveEvents.setup.label.select' | translate }}</h1>
<div mat-dialog-content>
  <mat-radio-group [(ngModel)]="liveEventType">
    <div class="radio-btn">
      <div class="icon">
        <mat-icon>live_tv</mat-icon>
        <p>&nbsp;&nbsp; {{ 'liveEvents.list.samples.default' | translate }}</p>
      </div>
      <mat-radio-button
        color="primary"
        value="Default"
        name="select"
      ></mat-radio-button>
    </div>
    <mat-divider></mat-divider>
    <div class="radio-btn">
      <div class="icon">
        <mat-icon>park</mat-icon>
        <p>
          &nbsp;&nbsp; {{ 'liveEvents.list.samples.christmas' | translate }}
        </p>
      </div>
      <mat-radio-button
        color="primary"
        value="Christmas"
        name="select"
      ></mat-radio-button>
    </div>
  </mat-radio-group>
</div>
<div mat-dialog-actions class="import-btn">
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onClick()">
    {{ 'common.button.import' | translate }}
  </button>
</div>
